import {TransData} from "@/common/dto/TransData";

export class TransUtils {
    static validateTransData(data: Partial<TransData>): TransData {
        if (!data.transactDate) throw new Error("날짜를 입력해주세요");
        if (data.amount === undefined || data.amount === null) throw new Error("금액을 입력해주세요");
        if (data.inAccountId === undefined || data.inAccountId === null) throw new Error("입금 계정을 선택해주세요");
        if (data.outAccountId === undefined || data.outAccountId === null) throw new Error("출금 계정을 선택해주세요");
        if (!data.detail || data.detail.trim() === "") throw new Error("적요를 입력해주세요");

        return {
            transactDate: data.transactDate,
            amount: data.amount,
            inAccountId: data.inAccountId,
            outAccountId: data.outAccountId,
            detail: data.detail.trim(),
        };
    }
}